var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDeploy = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#98c11d",
  d: "M5,11A6.094,6.094,0,0,1,6.006,7.451,3.488,3.488,0,0,1,9,6a4,4,0,0,1,3.617,2.289.971.971,0,0,0,.148.227.951.951,0,0,0,.136.13,1.051,1.051,0,0,0,.109.075,1,1,0,0,0,1.13-.076A3,3,0,0,1,19,11q0,.154-.015.3a3.065,3.065,0,0,1-.08.448,1,1,0,0,0,1.938.5A5,5,0,0,0,16,6a4.983,4.983,0,0,0-2.141.48A5.992,5.992,0,0,0,9,4,5.483,5.483,0,0,0,4.389,6.274,8.079,8.079,0,0,0,3,11a6.335,6.335,0,0,0,.113,1.187,1,1,0,0,0,1.965-.375q-.034-.177-.053-.353A4.031,4.031,0,0,1,5,11Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#98c11d",
  d: "M9.293,16.707a1,1,0,0,1,0-1.414l2-2a1,1,0,0,1,1.414,0l2,2a1,1,0,0,1-1.414,1.414L13,16.414V19a1,1,0,0,1-2,0V16.414l-.293.293A1,1,0,0,1,9.293,16.707Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeploy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deploy.834f4296.svg";
export { ForwardRef as ReactComponent };